import { render, staticRenderFns } from "./ReportPrinterByJson.vue?vue&type=template&id=1230d8ea&scoped=true"
import script from "./ReportPrinterByJson.vue?vue&type=script&lang=js"
export * from "./ReportPrinterByJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1230d8ea",
  null
  
)

export default component.exports